import React from "react";
import Footer from "./components/LayoutFooter";
import "./custom.css";
import ContactState from "./context/contact/ContactState";
import LoginState from "./context/login/LoginState";
import { AuthenticatedTemplate } from "@azure/msal-react";
import AppContent from "./AppContent";
import VendorState from "./context/vendor/VendorState";
import TranslationState from "./context/translation/TranslationState";

const App = () => {
  return (
    <>
      <LoginState>
        <AuthenticatedTemplate>
          <TranslationState>
            <VendorState>
              <ContactState>
                <AppContent />
              </ContactState>
            </VendorState>
          </TranslationState>
        </AuthenticatedTemplate>
      </LoginState>
    </>
  );
};

export default App;
